import { TranslatePipe } from '@ngx-translate/core';
import { Component, Input, OnInit } from '@angular/core';
import {
    Session,
    SessionService,
    Trainer,
    GraphQlService,
} from '../../../../_services';
import { TrainersLabelPipe } from '../../trainers-label.pipe';
import { FormatDatePipe } from '../../format-date.pipe';
import { LabelSkillComponent } from '../../label/label.component';
import { JhiLanguageService } from 'ng-jhipster';
import { Subject } from 'rxjs';
import { switchMap, distinctUntilChanged, filter } from 'rxjs/operators';

@Component({
    selector: 'staffing-search',
    templateUrl: 'staffing-search.component.html',
    styleUrls: [
        'staffing-search.component.scss',
        '../../label/label.component.scss',
    ],
    providers: [
        TrainersLabelPipe,
        FormatDatePipe,
        LabelSkillComponent,
        TranslatePipe,
    ],
})
export class StaffingSearchComponent implements OnInit {
    @Input() session: any;
    @Input() selectedTrainers: any;
    @Input() responses: any[];
    @Input() sendMailFunction: any;

    search = '';
    trainers: Trainer[] = [];
    agencies: Location[];
    selectedAgency = 'Toutes les agences';
    availableLanguages: string[] = [];
    selectedLanguage = 'all';
    isSendMailButtonActive = false;
    showOnlyActiveTrainers = true;

    filterMetadata = {
        countName: 0,
        countCan: 0,
        countGiven: 0,
        countWhised: 0,
        countFollowed: 0,
        countRefuse: 0,
    };

    searchTrainersSubject = new Subject<string>();

    constructor(
        private sessionService: SessionService,
        private graphQlService: GraphQlService
    ) {}

    ngOnInit(): void {
        this.searchTrainersSubject
            .pipe(
                filter((keyword) => keyword.length >= 2),
                distinctUntilChanged(),
                switchMap((keyword: string) =>
                    this.searchForTrainersByNameOrSkill(keyword)
                )
            )
            .subscribe((trainers) => (this.trainers = trainers));
        this.resetSearchBar();
        this.sessionService
            .findAllLocations()
            .subscribe((agencies) => (this.agencies = agencies));
        this.fetchAvailableLanguages();
    }

    private resetSelectedTrainerToSendMail() {
        Object.keys(this.selectedTrainers).map((trainerId) => {
            this.selectedTrainers[trainerId].selected = false;
        });
        this.isSendMailButtonActive = false;
    }

    private resetSearchBar() {
        if (this.session.training) {
            this.search = this.session.training.title;
        } else {
            this.search = '';
        }
        this.searchTrainersSubject.next(this.search);
    }

    sendMail(): void {
        const trainersToSendMail = Object.keys(this.selectedTrainers)
            .filter((trainerId) => this.selectedTrainers[trainerId].selected)
            .map((trainerId) => this.selectedTrainers[trainerId].trainer.id);

        this.sendMailFunction(this.session.id, trainersToSendMail).subscribe(
            (response) => {
                this.resetSearchBar();
                this.resetSelectedTrainerToSendMail();
            }
        );
    }

    updateSendMailButtonActive() {
        this.isSendMailButtonActive = false;
        Object.keys(this.selectedTrainers).forEach((trainerId) => {
            if (this.selectedTrainers[trainerId].selected) {
                this.isSendMailButtonActive = true;
            }
        });
    }

    toggleTrainerSelectedToSendMail(trainerId) {
        this.selectedTrainers[trainerId].selected =
            !this.selectedTrainers[trainerId].selected;
        this.updateSendMailButtonActive();
    }

    toggleShowOnlyActiveTrainers() {
        this.showOnlyActiveTrainers = !this.showOnlyActiveTrainers;
    }

    searchByNameOrSkill() {
        this.searchTrainersSubject.next(this.search);
    }

    searchForTrainersByNameOrSkill(keyword: string) {
        return this.graphQlService
            .post({
                query: `
                    query searchTrainers($keyword: String!) {
                        trainers: search_trainers_by_name_or_skill(args: { search: $keyword }) {
                            id
                            active
                            firstName: first_name
                            lastName: last_name
                            company {
                                name
                            }
                            trainerSkills: plt_trainer_skills {
                                can
                                followed
                                nbGiven: nb_given
                                wished
                                refuse
                                training {
                                    title
                                }
                            }
                            languages: trainer_languages {
                                code: language_code
                            }
                        }
                    }
                `,
                variables: {
                    keyword,
                },
            })
            .map((result) =>
                result.trainers
                    // this is to keep compatibility with trainer-card component
                    .map((trainer) => ({
                        ...trainer,
                        companyName: trainer.company.name,
                        trainerSkills: trainer.trainerSkills.map((skill) => ({
                            ...skill,
                            trainingName: skill.training.title,
                        })),
                    }))
            );
    }

    fetchAvailableLanguages() {
        this.graphQlService
            .post({
                query: `
                    query {
                        languages: language {
                            code
                        }
                    }
                `,
                variables: {},
            })
            .subscribe(({ languages }) => {
                this.availableLanguages = languages;
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/_shared/staffing/search/staffing-search.component.ts